const OSS_BASE_URL = process.env.VUE_APP_OSS_URL

export default {
  OSS_BASE_URL,
}
